import React, { ReactElement, useRef } from "react";
import { AriaListBoxOptions, useListBox } from "react-aria";
import { ListState, Node } from "react-stately";

import ListBoxOption from "@core/ui/atoms/list-box-option/ListBoxOption";

import * as styles from "@core/ui/molecules/list-box/ListBox.module.scss";

interface ListBoxProps extends AriaListBoxOptions<unknown> {
  listBoxRef?: React.RefObject<HTMLUListElement>;
  state: ListState<unknown>;
  listBoxWidth?: number;
}

const ListBox = (props: ListBoxProps): ReactElement => {
  const ref = useRef<HTMLUListElement>(null);
  const { listBoxRef = ref, state } = props;
  const { listBoxProps } = useListBox(props, state, listBoxRef);

  return (
    <ul
      {...listBoxProps}
      ref={listBoxRef}
      className={styles.listBox}
      style={{ width: props.listBoxWidth }}
    >
      {[...state.collection].map((item: Node<unknown>) => (
        <ListBoxOption key={item.key} item={item} state={state} />
      ))}
    </ul>
  );
};

export default ListBox;
